import { Feature, FEATURE_FLAGS } from "../configs/featureFlags";
import { Environment, getEnvironment } from "./environment";

const currentEnv: Environment = getEnvironment();

const getFeatureFlags = (): Record<Feature, boolean> => {
  return Object.fromEntries(
    (Object.keys(FEATURE_FLAGS) as Feature[]).map((key) => [
      key,
      FEATURE_FLAGS[key][currentEnv] ?? false
    ])
  ) as Record<Feature, boolean>;
};

export default getFeatureFlags;
